exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tab-container .tab-content[data-v-653b3ef4],.tab-container.trans-style ul.tabs li a[data-v-653b3ef4],.tab-wrapper[data-v-653b3ef4]{background:#f5f5f5}.tab-container.trans-style ul.tabs li.active a[data-v-653b3ef4]{color:#9f4378}ul.arrow-square[data-v-653b3ef4],ul.arrow[data-v-653b3ef4],ul.check-circle[data-v-653b3ef4],ul.check-square[data-v-653b3ef4],ul.check[data-v-653b3ef4],ul.chevron[data-v-653b3ef4],ul.circle[data-v-653b3ef4],ul.decimal[data-v-653b3ef4],ul.lower-latin[data-v-653b3ef4],ul.triangle[data-v-653b3ef4],ul.upper-latin[data-v-653b3ef4],ul.upper-roman[data-v-653b3ef4]{font-size:1.0833em}@media only screen and (min-device-width:768px) and (max-device-width:1024px){.toggle-container .panel.style1 .panel-content[data-v-653b3ef4]{padding:10px 15px 15px 10px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-653b3ef4","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/career/Home.vue
// module id = 550
// module chunks = 0